import { connect } from 'react-redux';
import { getAvailableAddons } from '../redux/actions/dinings';
import Dining from '../components/dining/Dining';
import { saveAddon } from '../redux/actions/changeAddon';
import { breakfastType, dinnerPage, shouldFetchDining, getShouldSkipDiningPage } from '../utils';

const mapStateToProps = ({ dinings, bookingSearch, config }) => ({
  diningSlots: dinings.diningSlots,
  title: 'Setup your experience',
  subTitle: 'Breakfast time?',
  separatorLabel: 'Dining room closed for deep clean',
  type: breakfastType,
  resId: bookingSearch.resId,
  redirectPath: dinnerPage,
  bookedAddon: dinings.bookedBreakfast,
  shouldFetchAvailableAddons: shouldFetchDining(dinings, bookingSearch, config),
  shouldSkip: getShouldSkipDiningPage(dinings, bookingSearch, breakfastType, config),
  optionsTitle: 'Choose breakfast time',
});

const mapDispatchToProps = dispatch => ({
  getAvailableAddons: resId => dispatch(getAvailableAddons(resId)),
  saveAddon: (resId, addonCode, action, isEditBooking) => dispatch(saveAddon(resId, addonCode, action, isEditBooking)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Dining);
